export default "__VITE_ASSET__91171313__"